var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _vm.isVisible(null, false) || _vm.alwaysShow
    ? _c(
        "v-btn",
        _vm._g(
          {
            attrs: {
              "data-test-id": "handleClick",
              absolute: _vm.absolute,
              "active-class": _vm.activeClass,
              append: _vm.append,
              block: _vm.block,
              bottom: _vm.bottom,
              color: _vm.color,
              dark: _vm.dark,
              depressed: _vm.depressed,
              disabled: _vm.disabled,
              exact: _vm.exact,
              "exact-active-class": _vm.exactActiveClass,
              fab: _vm.fab,
              fixed: _vm.fixed,
              text: _vm.flat,
              href: _vm.href,
              icon: _vm.icon,
              "input-value": _vm.inputValue,
              large: _vm.large,
              left: _vm.left,
              light: _vm.light,
              loading: _vm.loading,
              outlined: _vm.outlined,
              plain: _vm.plain,
              replace: _vm.replace,
              right: _vm.right,
              ripple: _vm.ripple,
              rounded: _vm.rounded,
              small: _vm.small,
              tag: _vm.tag,
              target: _vm.target,
              to: _vm.to,
              top: _vm.top,
              type: _vm.type,
              width: _vm.width,
            },
            on: { click: _vm.handleClick },
          },
          _vm.$listeners
        ),
        [
          _vm._t("default", function () {
            return [_vm._v(_vm._s(_vm.text))]
          }),
        ],
        2
      )
    : _vm._e()
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }